export default __webpack_public_path__ + "static/media/navileft.ff1d91e5.svg";